import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import BaseCsvExporter from '@/components/v2/BaseCsvExporter.vue';
import ActionButton from '@/components/action_button/Index.vue';
import moment from 'moment';
import { SHORTDATE_FORMAT } from '@/helpers/constants/app';
import BaseDatePicker from '@/components/datepicker/Index.vue';
import { required } from 'vuelidate/lib/validators';
import SalesFunnelData from '@/components/v2/ecommerce/SalesFunnelData';
let OrderExport = class OrderExport extends Mixins(RouterParamsAppMixin, FormMixin) {
    constructor() {
        super(...arguments);
        this.from = moment().format(SHORTDATE_FORMAT);
        this.to = moment().format(SHORTDATE_FORMAT);
    }
    csvData(data) {
        if (this.from && this.to) {
            Object.assign(data, { dateStart: moment(this.from).format(SHORTDATE_FORMAT) });
            Object.assign(data, { dateEnd: moment(this.to).format(SHORTDATE_FORMAT) });
        }
        return [data];
    }
    get minStart() {
        return moment().subtract(3, 'months').format(SHORTDATE_FORMAT);
    }
    get today() {
        return moment().format(SHORTDATE_FORMAT);
    }
    get labels() {
        const labels = {
            sessionCount: 'Session',
            addToCartCount: 'Add to Cart',
            checkoutCount: 'Checkout',
            orderSuccessCount: 'Order Success',
            dateStart: 'Date Start',
            dateEnd: 'Date End',
        };
        return Object.assign(labels);
    }
    get fields() {
        return Object.keys(this.labels);
    }
    exportFinish(message) {
        this.successNotification(message);
    }
};
__decorate([
    Prop({ type: String, required: true })
], OrderExport.prototype, "csvFileName", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], OrderExport.prototype, "initiatedFromAds", void 0);
OrderExport = __decorate([
    Component({
        components: {
            BaseCsvExporter,
            ActionButton,
            BaseDatePicker,
            SalesFunnelData,
        },
        validations() {
            return {
                from: {
                    required,
                },
                to: {
                    required,
                },
            };
        },
    })
], OrderExport);
export default OrderExport;
